import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BrowserSessionService {
    private readonly key = 'openflis.product-session-id';

    getSessionId(): string {
        let id = sessionStorage.getItem(this.key);

        if (!id) {
            id = crypto.randomUUID();
            sessionStorage.setItem(this.key, id);
        }

        return id;
    }

    reset(): void {
        sessionStorage.removeItem(this.key);
    }
}
